import { useQuery } from "react-query";
import { fetchSession } from "api/auth";

/**
 * Read the current cookie-based session via /auth/me. Replaces the Cognito-based
 * useGetCognitoSession — authentication is owned by the external portal and the
 * `.foo.com` session cookie, so this needs no token handling.
 *
 * @param {boolean} [enabled=true]
 * @returns {{ session: object | null, sessionLoading: boolean, sessionSuccess: boolean, refetchSession: () => void }}
 */
const useSession = (enabled = true) => {
  const { data, isLoading, isSuccess, refetch, ...rest } = useQuery(
    ["authSession"],
    () => fetchSession(),
    {
      enabled,
      retry: 2,
    }
  );

  return {
    // fetchSession returns { email, groups, session } or null
    session: data || null,
    sessionLoading: isLoading,
    sessionSuccess: isSuccess,
    refetchSession: refetch,
    ...rest,
  };
};

export default useSession;
